import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { BehaviorSubject, debounceTime, distinctUntilChanged, EMPTY, switchMap, takeUntil } from 'rxjs';
import { BaseComponent } from '../../../base.component';
import { Account } from '../../../../models/ui/account.model';
import { User } from '../../../../models/ui/user.model';
import { MatSelectionListChange } from '@angular/material/list';
import { UserManager } from '../../../../managers/user.manager';

@Component({
    selector: 'lex-manage-user-access-dialog-dialog',
    templateUrl: './manage-user-access-dialog.component.html',
    styleUrls: ['./manage-user-access-dialog.component.scss'],
    standalone: false
})
export class ManageUserAccessDialogComponent extends BaseComponent {

	public users: User[];
	public selectedAccount: Account = null;
	public isNewAccount: boolean = false;

	private searchTerm = new BehaviorSubject<string>('');
	private searchText: string = '';

	public selectedUserIds: string[] = [];
	public formChanged: boolean = false;
	public selection: SelectionModel<string>;

	constructor(
		private dialogRef: MatDialogRef<ManageUserAccessDialogComponent>,
		private userManager: UserManager,
		@Inject(MAT_DIALOG_DATA) private data: ManageUserAccessDialogData) {
		super();
		this.isNewAccount = this.data?.isNewAccount;
		this.selectedAccount = this.data?.selectedAccount;
		this.searchTerm.pipe(
			debounceTime(500),
			distinctUntilChanged(),
			switchMap((term: string) => {
				this.searchText = term;
				return EMPTY;
			}),
			takeUntil(this.destroy$)
		).subscribe();
		this.userManager.getActiveUsers('', ['UserName', "asc"]).subscribe(data => {
			this.users = data;
		});
		if(!this.isNewAccount)
			this.selectedUserIds = this.selectedAccount?.users?.map(x => x.id);
		this.selection = new SelectionModel<string>(true, this.selectedUserIds);
	}

	public filterUsers(users: User[]): User[] {
		if (this.searchText) {
			return users.filter(x =>
				x.userName.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
		}
		return users;
	}

	public submit(): void {
		this.selectedUserIds = this.selection.selected;
		this.dialogRef.close(this.selectedUserIds);
	}

	public updateSearch(term: string): void {
		this.searchTerm.next(term);
	}

	public changeUserIds(selection: MatSelectionListChange): void {
		selection.options.forEach((option) => {
			if (option.selected) {
				this.selection.select(option.value);
			} else {
				this.selection.deselect(option.value);
			}
		});
		if (!this.formChanged)
			this.formChanged = true;
	}
}

export interface ManageUserAccessDialogData {
	isNewAccount?: boolean;
	selectedAccount: Account;
}
